import { createContext, useContext, useState, useEffect } from "react";
import { api, setAuthToken } from "../utils/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [uniqueId, setUniqueId] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // On app load, restore tokens from localStorage
  useEffect(() => {
    const storedAccess = localStorage.getItem("accessToken");
    const storedRefresh = localStorage.getItem("refreshToken");
    const storedUniqueId = localStorage.getItem("uniqueId");

    if (storedAccess && storedRefresh && storedUniqueId) {
      setAccessToken(storedAccess);
      setRefreshToken(storedRefresh);
      setUniqueId(storedUniqueId);
      setAuthToken(storedAccess);
    }
    setLoading(false);
  }, []);

  const login = (tokens, uid) => {
    setAccessToken(tokens.accessToken);
    setRefreshToken(tokens.refreshToken);
    setUniqueId(uid);

    localStorage.setItem("accessToken", tokens.accessToken);
    localStorage.setItem("refreshToken", tokens.refreshToken);
    localStorage.setItem("uniqueId", uid);

    setAuthToken(tokens.accessToken);
  };

  const logout = () => {
    setAccessToken(null);
    setRefreshToken(null);
    setUniqueId(null);

    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("uniqueId");

    setAuthToken(null);
  };

  return (
    <AuthContext.Provider
      value={{
        uniqueId,
        accessToken,
        refreshToken,
        setUniqueId,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
